import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faSpinner, faBuilding } from '@fortawesome/free-solid-svg-icons';
import { createEntity } from '../../../services/corporateStructureService';
import './CreateGroupModal.css';

const CreateEntityModal = ({ groupId, groupName, existingEntities, onClose, onCreated }) => {
  const [formData, setFormData] = useState({
    entity_name: '',
    trading_short_name: '',
    shareholder_note: '',
    country: '',
    country_code: '',
    base_currency: '',
    currency_conversion_note: '',
    parent_entity: '',
    has_fibu: true,
    has_kreditorenbuch: true,
    has_debitorenbuch: true,
    has_lohnbuchhaltung: false,
    has_vat_obligation: false,
    has_taccounting: false,
    in_consolidation_circle: false,
    node_color: '#4a6b25',
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.entity_name.trim() || !formData.country.trim() || !formData.country_code.trim() || !formData.base_currency.trim()) {
      setError('Entity name, country, country code, and currency are required');
      return;
    }
    try {
      setSaving(true);
      setError(null);
      const payload = {
        ...formData,
        entity_name: formData.entity_name.trim(),
        parent_entity: formData.parent_entity || null,
        group: groupId,
      };
      await createEntity(groupId, payload);
      onCreated();
    } catch (err) {
      console.error('Failed to create entity:', err);
      const errData = err.response?.data;
      const msg = errData?.entity_name?.[0] || errData?.non_field_errors?.[0] || 'Failed to create entity';
      setError(msg);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="sg-modal-overlay" onClick={onClose}>
      <div className="sg-modal sg-modal-wide" onClick={e => e.stopPropagation()}>
        <div className="sg-modal-header">
          <h3>
            <FontAwesomeIcon icon={faBuilding} />
            Add Entity to {groupName}
          </h3>
          <button className="edp-close" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="sg-modal-body">
            {error && <div className="sg-modal-error">{error}</div>}

            <label className="sg-modal-label">
              Entity Name *
              <input className="sg-modal-input" value={formData.entity_name} onChange={e => handleChange('entity_name', e.target.value)} placeholder="e.g., AMS Holding AG" autoFocus />
            </label>

            <label className="sg-modal-label">
              Parent Entity
              <select className="sg-modal-select" value={formData.parent_entity} onChange={e => handleChange('parent_entity', e.target.value)}>
                <option value="">None (Top-level entity)</option>
                {existingEntities.map(ent => (
                  <option key={ent.id} value={ent.id}>{ent.entity_name}</option>
                ))}
              </select>
            </label>

            <div className="sg-modal-row">
              <label className="sg-modal-label">
                Country *
                <input className="sg-modal-input" value={formData.country} onChange={e => handleChange('country', e.target.value)} placeholder="Switzerland" />
              </label>
              <label className="sg-modal-label">
                Code *
                <input className="sg-modal-input" value={formData.country_code} onChange={e => handleChange('country_code', e.target.value)} placeholder="CH" maxLength={3} />
              </label>
              <label className="sg-modal-label">
                Currency *
                <input className="sg-modal-input" value={formData.base_currency} onChange={e => handleChange('base_currency', e.target.value)} placeholder="CHF" maxLength={3} />
              </label>
            </div>

            <label className="sg-modal-label">
              Shareholder Note
              <input className="sg-modal-input" value={formData.shareholder_note} onChange={e => handleChange('shareholder_note', e.target.value)} placeholder="e.g., Shareholder with 100%" />
            </label>

            <label className="sg-modal-label">
              Currency Conversion Note
              <input className="sg-modal-input" value={formData.currency_conversion_note} onChange={e => handleChange('currency_conversion_note', e.target.value)} placeholder="e.g., CHF converted to USD for reporting" />
            </label>

            <label className="sg-modal-checkbox">
              <input type="checkbox" checked={formData.in_consolidation_circle} onChange={e => handleChange('in_consolidation_circle', e.target.checked)} />
              Consolidation Circle
            </label>

            <label className="sg-modal-label">
              Node Color
              <input type="color" className="sg-modal-input" value={formData.node_color} onChange={e => handleChange('node_color', e.target.value)} style={{ height: 36, cursor: 'pointer' }} />
            </label>
          </div>
          <div className="sg-modal-footer">
            <button type="button" className="sg-btn sg-btn-secondary" onClick={onClose}>Cancel</button>
            <button type="submit" className="sg-btn sg-btn-primary" disabled={saving}>
              <FontAwesomeIcon icon={saving ? faSpinner : faBuilding} spin={saving} />
              {saving ? 'Creating...' : 'Add Entity'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateEntityModal;
